export const getConsultations = async () => {
  return await fetch(
    "https://new.smartiscity.gr/api/api.php?func=getConsultations"
  )
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
      return error.message;
    });
};

export const camelCaseText = (text) => {
  const words = text.split(" ");
  //   console.log("TEST slitted text: ", words);
  const sentence = words.map((word) => {
    return word.replace(
      /([«(]?)([Α-Ωα-ωΆ-Ώά-ώA-Za-z])([Α-Ωα-ωΆ-Ώά-ώA-Za-z]*)/g,
      (match, prefix, first, rest) => {
        return `${prefix ?? null}${first.toUpperCase()}${rest.toLowerCase()} `;
      }
    );
  });
  let temp = sentence.join(" ");
  for (let i = 0; i < temp.length; i++) {
    if (
      (temp[i] === " " && temp[i + 1] === ".") ||
      (temp[i] === " " && temp[i + 1] === ")") ||
      (temp[i] === " " && temp[i + 1] === "»")
    ) {
      temp = temp.slice(0, i) + temp.slice(i + 1);
      i--;
    }
  }
  return temp;
};
